import { render, staticRenderFns } from "./132.vue?vue&type=template&id=f9122b86&scoped=true&"
var script = {}
import style0 from "./132.vue?vue&type=style&index=0&id=f9122b86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9122b86",
  null
  
)

export default component.exports